import React, { useEffect, useRef, useState, useMemo, useCallback, memo, useContext } from "react";
import { UserWalletDashboard } from "../../Pages/All/UserWalletDashboard.jsx";
import Flickity from 'flickity';
import 'flickity/css/flickity.css';
import { Game } from "./Game.jsx";
import UtrkeWidgetTab from "./UtrkeWidgetTab.jsx";
import { WebSocketContext } from "./WSContext.jsx";


const removeGameFrameListeners = () => {
    const gameFrame = document.getElementById("gameFrame");
    if (gameFrame) {
        const clone = gameFrame.cloneNode(true);
        gameFrame.parentNode.replaceChild(clone, gameFrame);
    }
};

const handleLoginClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    removeGameFrameListeners();
    window.location.href = "https://mcasino.supersport.hr/login";
};

const handleRegisterClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    removeGameFrameListeners();
    window.location.href = "https://m.supersport.hr/registracija";
};

const getAmountClass = (amount) =>
    amount < 100 ? "bronze" : amount < 1000 ? "silver" : "gold";


const isDarkMode = () => {
    // za sad samo light mode dok ne popravim
    //const casinoTheme = localStorage.getItem("darkModeStrategy") || "light";
    const casinoTheme = "light"
    if (casinoTheme === "system") {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? true : false;
    } else {
        return casinoTheme === "dark";
    }
};

const UserWallet = (props, novcanikTab) => {
    return (
        <div className="wallet-container">
            <UserWalletDashboard {...props} activeTab={novcanikTab} isFromWidget={true} />
        </div>
    );
};

const Winners = memo(({ gameInfo }) => {
    return (
        <div className="container-promo">
            <div className="title">Dobitci u igri</div>
            <div className="title-2">Najveći dobitci u ovoj igri</div>
            {gameInfo && gameInfo.najveciDobici && gameInfo.najveciDobici.length > 0 ? (
                gameInfo.najveciDobici.map((dobitak, index) => (
                    <div className="winner-row" key={index}>
                        <div className="left">
                            <div className="user">{dobitak.imeZaPrikaz}</div>
                            <div className="date">{dobitak.datumZaPrikaz}</div>
                        </div>
                        <div className="right">
                            <div className={"amount " + getAmountClass(dobitak.dobitakEuro)}>
                                {casino.utils.numberWithCurrencyFromated(dobitak.dobitakEuro, "EUR")}
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p className="desc">Nema dostupnih dobitaka za ovu igru.</p>
            )}
            <div className="title-2">Posljednji dobitci u ovoj igri</div>

            {gameInfo &&
                gameInfo.najveciDobici &&
                gameInfo.posljednjiDobici.length > 0 ? (
                gameInfo.posljednjiDobici.map((dobitak, index) => (
                    <div className="winner-row" key={index}>
                        <div className="left">
                            <div className="user">{dobitak.imeZaPrikaz}</div>
                            <div className="date">{dobitak.datumZaPrikaz}</div>
                        </div>
                        <div className="right">
                            <div className={"amount " + getAmountClass(dobitak.dobitakEuro)}>
                                {casino.utils.numberWithCurrencyFromated(dobitak.dobitakEuro, "EUR",)}
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p className="desc">Nema dostupnih dobitaka za ovu igru.</p>
            )}
        </div>
    );
});

const FlickityCarouselSimilarGames = memo((props) => {
    const carouselGamesRef = useRef(null);

    const filteredGames = useMemo(() => {
        if (!props.brands || !props.gamecode || !props.games || !props.similarGames) return [];
        return props.similarGames.reduce((acc, similarGame) => {
            const game = props.games.find(x => x.s === similarGame.sifraMobile && x.s !== props.gamecode);
            if (game) acc.push(game);
            return acc;
        }, []);
    }, [props.brands, props.gamecode, props.games, props.similarGames]);

    useEffect(() => {
        const flickityOptionsGames = {
            draggable: true,
            prevNextButtons: false,
            cellAlign: 'left',
            fade: false,
            selectedAttraction: 1,
            friction: 0.5,
            wrapAround: true,
            imagesLoaded: true,
            pageDots: false,
            freeScroll: true
        };

        const flickityGames = new Flickity(carouselGamesRef.current, flickityOptionsGames);

        return () => {
            flickityGames.destroy();
        };
    }, [filteredGames]);

    return (
        <div key="similar_games" ref={carouselGamesRef} className="similar-games-carousel">
            {filteredGames.map(game => (
                <div key={game.s} className="flickity-item">
                    <Game key={"game" + game.s} igra={game} brands={props.brands} fromNative={true} />
                </div>
            ))}
        </div>
    );
});

const Info = ({ gameInfo, game, games, brands, user, toggleFavoritGameFn }) => {
    let provider = brands[game.bID] ? brands[game.bID] : null;
    let providerImgUrl = provider && (casino.config.gameImagesUrl + provider.nameNormalizirano + '/logos/logo' + '.png' + '?c=' + casino.config.guiCacheVerzija);
    let isFavorite = user && user.favoriti.indexOf(game.id) === -1 ? false : true;
    let gameInfoLink = `https://mcasino.supersport.hr/game/${provider.nameNormalizirano}/${casino.utils.normalizeString(game.n)}/info`;

    const toggleFavoritGame = () => {
        toggleFavoritGameFn(game);
    };

    return (
        <>
            <div className="container-promo">
                <div className="title">Info igre</div>
                <div className="title-2">{game.n}</div>
                {game.jp && (
                    <div className="jackpot-info">
                        <span className="jackpot-icon"></span>
                        <div className="jackpot-amount">
                            {casino.utils.numberWithCurrencyFromated(game.jp, "EUR")}
                        </div>
                    </div>
                )}
                {gameInfo.liveRTP > 0 && (
                    <div className="info-row">
                        <span className="label">Live RTP</span>
                        <span className="value">
                            <span className={"rtp"}>
                                {gameInfo.liveRTP}%
                                <span className="rtp-icon"></span>
                            </span>
                        </span>
                    </div>
                )}
                {gameInfo.brojIgraca > 0 && (
                    <div className="info-row">
                        <span className="label">Trenutno igra igru</span>
                        <span className="value">
                            <span className={"players"}>
                                <span className="user-icon"></span>
                                {gameInfo.brojIgraca}
                            </span>
                        </span>
                    </div>
                )}
                {gameInfo.opis &&
                    <div className="info-row" onClick={() => window.open(gameInfoLink)}>
                        <span className="label">Saznaj više o igri</span>
                        <span className="value">
                            <span className="chevron-right-icon"></span>
                        </span>
                    </div>}
                {user && <div className="info-row" onClick={toggleFavoritGame}>
                    <span className="label">
                        {isFavorite ? "Ukloni iz favorita" : "Dodaj u favorite"}</span>
                    <span className="value">
                        <span className={`favorite-icon ${isFavorite ? "active" : ""}`}></span>
                    </span>
                </div>}
                {gameInfo.similarGames && gameInfo.similarGames.length > 0 && <>
                    <div className="divider mt-0"></div>
                    <div className="title-3 mb-12">Zaigraj slične igre</div>
                    <FlickityCarouselSimilarGames gamecode={gameInfo?.sifraIgre} similarGames={gameInfo?.similarGames} games={games} brands={brands} />
                </>}
                <div className="divider mt-0"></div>
                <div className="title-3 mb-12">Provider</div>
                <a href={`https://mcasino.supersport.hr/provideri?provider=${provider.nameNormalizirano}`} className="provider-link">
                    <img className="provider-logo" src={providerImgUrl} alt={provider.name} />
                </a>
            </div>
        </>
    );
};

const UserPromo = memo(() => {
    return (
        <div className="container-promo">
            <div className="title">Novčanik</div>

            <div className="title-2">Prijavi se za sudjelovanje</div>
            <p className="desc">
                Prijavi se kako bi mogao sudjelovati u Super Promocijama, Super
                Turnirima, igrati za prave dobitke i ostavajati super nagrade.
            </p>
            <div className="login-or-register">
                <a className="login-btn" href="#" onClick={handleLoginClick}>
                    Prijava
                </a>
                <a className="register-btn" href="#" onClick={handleRegisterClick}>
                    Registracija
                </a>
            </div>
            <div className="divider"></div>
            <div className="promo-steps">
                <div className="promo-steps-title">Bonus za registraciju</div>
                <div className="promo-step promo-step-1 border-bottom">
                    <span className="step-icon"></span>
                    <div className="step-text">
                        <div className="text-1">Registriraj se</div>
                        <div className="text-2">Osvoji 100 BESPLATNIH VRTNJI</div>
                    </div>
                </div>
                <div className="promo-step promo-step-2 border-bottom">
                    <span className="step-icon"></span>
                    <div className="step-text">
                        <div className="text-1">Uplata</div>
                        <div className="text-2">Osvoji 300 € BONUSA</div>
                    </div>
                </div>
                <div className="promo-step promo-step-3">
                    <span className="step-icon"></span>
                    <div className="step-text">
                        <div className="text-1">Uplati još</div>
                        <div className="text-2">Osvoji 400 BESPLATNIH VRTNJI</div>
                    </div>
                </div>
            </div>
        </div>
    );
});

const TournamentsPromo = memo(() => {
    return (
        <div className="container-promo">
            <div className="title">Turniri</div>
            <div className="tournament-lik"></div>
            <div className="title-2">Turniri te čekaju!</div>
            <p className="desc">
                Prijavi se kako bi vidio sve aktivne turnire. Igre i nagrade te čekaju.
                Provjeri sve i odaberi najbolju za tebe.
            </p>
        </div>
    );
});

const InGameModal = memo(({ visible, onClose, gameId, gameInfo, game, games, brands, activeTab, setActiveTab, connectionError, novcanikTab, ...props }) => {
    return (
        <div
            className={"in-game-modal-overlay" + (visible ? " visible" : "") + (isDarkMode() ? " dark-mode" : "")}
            onClick={onClose}
        >
            <div className={"in-game-modal"} onClick={(e) => e.stopPropagation()}>
                <div className="in-game-modal-header">
                    <span className="close-icon" data-action="close-modal"></span>
                    <span className="supercasino-logo"></span>
                    <div className="in-game-tabs">
                        <span
                            className={"tab wallet " + (activeTab === 1 ? "active" : "")}
                            data-action="set-tab-1"
                        >
                            <span className="tab-icon"></span>
                        </span>
                        {!connectionError && <span
                            className={"tab tournament " + (activeTab === 2 ? "active" : "")}
                            data-action="set-tab-2"
                        >
                            <span className="tab-icon"></span>
                        </span>}
                        {/*{gameInfo && gameInfo.opis && <> <span*/}
                        {/*    className={"tab tournaments " + (activeTab === 3 ? "active" : "")}*/}
                        {/*    onClick={() => setActiveTab(3)}*/}
                        {/*>*/}
                        {/*    <span className="tab-icon"></span>*/}
                        {/*</span>*/}
                        {/*    <span*/}
                        {/*        className={"tab info " + (activeTab === 4 ? "active" : "")}*/}
                        {/*        onClick={() => setActiveTab(4)}*/}
                        {/*    >*/}
                        {/*        <span className="tab-icon"></span>*/}
                        {/*    </span>*/}
                        {/*</>}*/}
                    </div>
                </div>

                <div className="in-game-modal-content">
                    {activeTab === 1 && props.user && <UserWallet {...props} novcanikTab={novcanikTab} />}
                    {activeTab === 1 && !props.user && <UserPromo {...props} />}
                    {activeTab === 2 && props.user && < UtrkeWidgetTab playerID={props.user.igracID} gameID={gameId} />}
                    {activeTab === 2 && !props.user && <TournamentsPromo />}
                    {/*{activeTab === 3 && <Winners gameInfo={gameInfo} />}*/}
                    {/*{activeTab === 4 && <Info gameInfo={gameInfo} game={game} games={games} brands={brands} user={props.user} toggleFavoritGameFn={props.toggleFavoritGameFn} />}*/}
                </div>
            </div>
        </div>
    );
});

const InGameWidget = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [game, setGame] = useState(null);
    const [gameInfo, setGameInfo] = useState(null);
    const [games, setGames] = useState(null);
    const [brands, setBrands] = useState(null);
    const [activeTab, setActiveTab] = useState(1);
    const [novcanikTab, setNovcanikTab] = useState("casino")
    const gameId = useMemo(() => new URLSearchParams(window.location.search).get("id"), []);
    const [isLoading, setIsLoading] = useState(true);
    const walletRef = useRef(null);


    const [ready, val, send, connectionError] = useContext(WebSocketContext);
    const [tournament, setTournament] = useState(null);
    const [myPositionState, setMyPositionState] = useState(null);
    const [results, setResults] = useState([]);
    const [minResults, setMinResults] = useState([]);



    const getGames = () => {
        casino.repos.gameRepo.list().then((data) => {
            setGames(data.items);
            setBrands(data.brandovi);
            let game = data.items.find((g) => g.id === parseInt(gameId));
            setGame(game);
            if (game) {
                casino.repos.seoGameInfoRepo.get(game.s).then((seoData) => {
                    setGameInfo(seoData);
                });
            }
        });
    };

    useEffect(() => {
        getGames();
        const topBar = document.getElementById('app-play');


        // A single listener that intercepts EVERYTHING inside the modal
        topBar.addEventListener('touchstart', (e) => {
            console.log("start")
            const interactiveTarget = e.target.closest('button[data-action],div[data-action] , span[data-action], a[data-action]');
            // If the user tapped empty space in the modal, do nothing (iframe stays alive)
            console.log(interactiveTarget)
            if (!interactiveTarget) { return };
            const action = interactiveTarget.dataset.action;
            if (!(action == "prebaci-na-casino" || action == "prebaci-na-sport")) {
                e.preventDefault();
            };


            // 3. Route the click to the correct action based on an HTML attribute
            console.log(action)
            switch (action) {
                case 'open-quick-menu':
                    handleQuickMenuClick();
                    break;
                case 'tournament-open':
                    handleTournamentClick();
                    break;
                case 'close-modal':
                    handleClose();
                    break;
                case 'set-tab-1':
                    setActiveTab(1);
                    break;
                case 'set-tab-2':
                    setActiveTab(2);
                    break;
                case 'uplata-click':
                    window.location.href = casino.config.urls.uplata;
                    break;
                //case 'isplata-click':
                //    window.location.href = "https://m.supersport.hr/racun#/isplata";
                //    break;
                case 'active-tab-casino':
                    setNovcanikTab("casino");
                    break;
                case 'active-tab-sport':
                    setNovcanikTab("sport");
                    break;
                default:
                    console.log('Unknown button action:', action);
            }
        }, { passive: false });

        topBar.addEventListener('touchend', (e) => {
            console.log("end")
            const interactiveTarget = e.target.closest('button,div[data-action] , span[data-action], a[data-action]');
            if (!interactiveTarget) {
                if (e.cancelable)
                    e.preventDefault();

                return
            };
            const action = interactiveTarget.dataset.action;
            if (!(action == "prebaci-na-casino" || action == "prebaci-na-sport")) {
                e.preventDefault();
            };

        })

    }, []);

    const handleClose = useCallback(() => setShowModal(false), []);
    const handleQuickMenuClick = useCallback(() => { setShowModal(true); setActiveTab(1); }, []);
    const handleTournamentClick = useCallback(() => { setShowModal(true); setActiveTab(2); }, []);

    useEffect(() => {
        if (ready && !connectionError && game) {
            send(JSON.stringify({ type: "subscribe", topic: "leaderboard", data: { gameID: game.id, playerID: props.user.igracID } }));
            send(JSON.stringify({ type: "tournament", data: { playerID: props.user.igracID, limit: 50, gameID: game.id } }));


        }
    }, [ready, connectionError, game])


    useEffect(() => {
        if (val != null) {
            parseData(val);
        }
    }, [val])



    const parseData = (data) => {
        var x = JSON.parse(data);
        switch (x.type) {
            case "leaderboardResponse":
                setMyPositionState(x.data?.find(x => x.isMe)?.rank);
                setResults(x);
                if (x.length !== 0 && x.data.length != 0) {
                    const playerResultIndex = x.data.findIndex(x => x.isMe);
                    //ako je manje od 3 rezultata, zemi sve
                    if (x.data.length <= 3) {
                        setMinResults(x.data);
                    }
                    //ako je vise, onda gledam koje 3 uzimam
                    else {
                        if (playerResultIndex !== -1) {
                            // uzimam 3 rezultata
                            let start = playerResultIndex - 1;
                            let end = playerResultIndex + 2;
                            //edge case ako je igrac prvi
                            if (start < 0) {
                                start = 0;
                                end = 3;
                            }
                            //edge case ako je igrac zadnji
                            if (end > x.data.length) {
                                end = x.data.length;
                                start = x.data.length - 3;
                            }
                            setMinResults(x.data.slice(start, end));
                        }
                        else {
                            setMinResults(x.data.slice(x.data.length - 3, x.data.length));
                        }
                    }
                }
                break;
            case "tournamentResponse":
                setTournament(x.data[0]);
                setIsLoading(false)
                break;
            default:
                break;
        }

    }



    return (
        <>
            <div className={"in-game-widget"}>
                <div className="quick-menu" data-action="open-quick-menu">
                    <span className="super-icon"></span>
                    <span className="menu-text">BRZI MENI</span>
                </div>
                {props.user && tournament && <div className="tournament-menu" data-action="tournament-open">
                    {myPositionState && <>
                        <span className="medal-icon"></span>
                        <div className="info-text">{myPositionState}</div>
                    </>}
                    <span className="time-icon"></span>
                </div>}
            </div>
            <InGameModal
                visible={showModal}
                onClose={handleClose}
                gameId={gameId}
                gameInfo={gameInfo}
                game={game}
                games={games}
                brands={brands}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                connectionError={connectionError}
                novcanikTab={novcanikTab}
                {...props}
            />
        </>
    );
};

export default InGameWidget;
